var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 96 97",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0.5C21.504 0.5 0 22.004 0 48.5C0 74.996 21.504 96.5 48 96.5C74.496 96.5 96 74.996 96 48.5C96 22.004 74.496 0.5 48 0.5ZM48 10.1C69.168 10.1 86.4 27.332 86.4 48.5C86.4 55.7 84.384 62.42 80.928 68.18C71.52 60.5 59.856 56.276 47.52 56.276C35.184 56.276 24.096 60.308 14.784 67.7C11.52 62.036 9.6 55.508 9.6 48.5C9.6 27.332 26.832 10.1 48 10.1ZM20.592 75.332C28.224 69.236 37.68 65.876 47.52 65.876C57.36 65.876 67.296 69.38 74.976 75.764C68.016 82.628 58.512 86.9 48 86.9C37.488 86.9 27.552 82.484 20.592 75.332Z",
    fill: "fillColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5199 54.404C59.1839 54.404 68.6399 44.948 68.6399 33.284C68.6399 21.62 59.1839 12.164 47.5199 12.164C35.8559 12.164 26.3999 21.62 26.3999 33.284C26.3999 44.948 35.8559 54.404 47.5199 54.404ZM47.5199 21.764C53.8559 21.764 59.0399 26.948 59.0399 33.284C59.0399 39.62 53.8559 44.804 47.5199 44.804C41.1839 44.804 35.9999 39.62 35.9999 33.284C35.9999 26.948 41.1839 21.764 47.5199 21.764Z",
    fill: "fillColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboAvatar);
export default __webpack_public_path__ + "static/media/FBOAvatar.913d782d019ca90b5a4227691182c498.svg";
export { ForwardRef as ReactComponent };